import { graphql } from '@gql';

export const USER_EVENTS = graphql(`
    subscription UserEvents {
        userEvents {
            type
            status
            resourceID
            message
        }
    }
`);
